// =====================================
//
//   resendInvitation Modal
//   Author: Gray
//   createtime: 2016 / 07 / 12
//   updatetime: 2016 / 07 / 12
//
// =====================================

window.InifECApp.directive('resendInvitation', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'UserService', 'BusinessMemberService',
    function($rootScope, $stateParams, $timeout, $ngModal, UserService, BusinessMemberService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var resendInvitaion = function(){
                
                if($scope.isSendding) {
                    return;
                }

                $scope.isEmailError = false;
                $scope.isMemberNotExist = false;
                $scope.isMember = false;
                $scope.isSystemError = false;

                if(!$scope.form.email || !isEmail($scope.form.email)){
                    $scope.isEmailError = true;
                    return;
                }

                $scope.isSendding = true;

                var _resendInvitaion = UserService.resendInvitaion;

                if($scope.isBusinessMember) {
                    _resendInvitaion = BusinessMemberService.resendInvitation
                }

                _resendInvitaion($scope.form.email).then(function(){
                    $scope.isSendding = false;
                    $scope.isSuccess = true;                    
                }, function(error){
                    $scope.isSendding = false;
                    if(error.code === 'error.apply.applicationSuccess'){
                        $scope.isMember = true;
                    }else if(error.code === 'error.apply.noApplied'){
                        $scope.isMemberNotExist = true;
                    }else{
                        $scope.isSystemError = true;
                    }
                });
            }

            var openModal = function() {
                $ngModal.openModal('resend-invitation-modal');
            }

            var closeModal = function() {
                $ngModal.closeModal('resend-invitation-modal');
            }

            var init = function() {

            }

            /*==========================
                Events
            ==========================*/
            $scope.$on('OPEN_RESEND_INVITATION_MODAL', function(event, data) {

                $scope.form.email = '';
                $scope.isSuccess = false;
                $scope.isEmailError = false;
                $scope.isMemberNotExist = false;
                $scope.isMember = false;
                $scope.isSystemError = false;

                if(data) {
                    $scope.form.email = data.email;
                    $scope.isBusinessMember = data.isBusinessMember || false;
                }

                openModal();
            })

                
            /*==========================
                Members
            ==========================*/

            $scope.form = {
                email: ''
            };
            $scope.isSendding = false;
            $scope.isEmailEmpty = false;
            $scope.isEmailError = false; // error.formValidator.invalidMailFormat
            $scope.isMember = false; // error.apply.applicationSuccess
            $scope.isMemberNotExist = false; // error.account.accountNotExist
            $scope.isSystemError = false;
            $scope.isSuccess = false;
            $scope.isBusinessMember = false;

            /*==========================
                Methods
            ==========================*/

            $scope.resendInvitaion = resendInvitaion;

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/resend_invitation.html';
        _dir.controller = controller;

        return _dir;
}]);